/**
 * 3자리 수 마다 comma(,)
 */
export const commaRegEx = /\B(?=(\d{3})+(?!\d))/g;
